/** @jsx jsx */
import { jsx, css } from '@emotion/react';

const STYLES = {
  content: css`
    justify-content: flex-end;
    display: flex;
    flex: 1;
    margin-top: 10px;
    position: absolute;
    width: 100vw;
    right: 15px;
    bottom: 15px;
  `,
  button: css`
    cursor: pointer;
    padding: .3rem 1rem;
    border: .1rem solid #0033CC;
    border-radius: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 30px;
    color: #ffffff;
    background-color: #0033CC;

    > * {
      color: white !important;
    }

    &:hover {
      background-color: #002699 !important;
      border-color: #002699;
      color: white !important;
    }

    &:focus,
    &:active {
      background-color: #002699 !important;
      border-color: #002699;
      box-shadow: none;
      outline: none;
    }

    &:disabled {
      background-color: #C2C4D0 !important;
      border-color: #C2C4D0;
    }
  `
};

export default function ButtonNext ({ shareTimings = {}, onClick }) {
  let keys = Object.keys(shareTimings).length;
  if (keys > 0) {
    return (
      <div
        css={STYLES.content}
      >
        <button
          type='button'
          css={STYLES.button}
          disabled={keys === 0}
          onClick={() => onClick()}
        >
          Show Preview
        </button>
      </div>
    );
  }

  return null;
}